import Velocity from "velocity-animate";

function scrollToIndex(list, items, index, snappableItems = null) {
  if (!list) return;

  snappableItems = snappableItems || items;
  index = index >= items.length ? items.length : index;
  const target = items[index];
  if (!target) return;

  //A fix for Chrome and Firefox browsers that temporairily disables the snapping so that we can animate the scroll position
  if (
    window.chrome ||
    navigator.userAgent.toLowerCase().indexOf("firefox") > -1
  ) {
    list.classList.add("is-no-scroll-snap");
  }
  Velocity(target, "scroll", {
    container: list,
    axis: "x",
    offset: -list.offsetLeft,
    duration: 800,
    easing: "ease-in-out",
    complete: () => {
      if (
        window.chrome ||
        navigator.userAgent.toLowerCase().indexOf("firefox") > -1
      ) {
        list.classList.remove("is-no-scroll-snap");
      }
    },
  });
}

function getItemWidth(item) {
  return item.clientWidth;
}

function getScrollInfo(list, items, pages = 0) {
  const listWidth = list.clientWidth;
  const widthAdjustment = listWidth * pages;
  const totalX = list.scrollWidth;
  const currentX = list.scrollLeft;
  const newX = currentX + widthAdjustment;
  const itemWidth = items.length ? getItemWidth(items[0]) : 0;
  let totalLength = Math.floor(totalX / itemWidth);
  let visibleLength = Math.floor(listWidth / itemWidth);
  let currentIndex = Math.max(0, currentX) / itemWidth;
  currentIndex = Math.ceil(currentIndex);
  const scrollableLength = totalLength - visibleLength;
  let newIndex = Math.min(Math.max(0, newX) / itemWidth, scrollableLength);
  newIndex = pages > 0 ? Math.floor(newIndex) : Math.ceil(newIndex);

  return {
    visibleLength,
    scrollableLength,
    totalLength,
    currentIndex,
    newIndex,
    reachedStart: newIndex === 0,
    reachedEnd: scrollableLength === newIndex,
    stuckAtStart: currentIndex === 0 && newIndex === 0,
    stuckAtEnd:
      scrollableLength === currentIndex && scrollableLength === newIndex,
  };
}

function scrollByPages(list, items, pages, snappableItems = null) {
  const scrollInfo = getScrollInfo(list, items, pages);
  if (list) {
    scrollToIndex(list, items, scrollInfo.newIndex, snappableItems);
  }
  return scrollInfo;
}

function scrollToElementIfNotInViewport(element, offset = -15, callback) {
  const rect = element.getBoundingClientRect();
  if (rect.top >= 0 && rect.bottom <= window.innerHeight) return;

  scrollToElement(element, offset, callback);
}

function scrollToElement(element, offset = -15, callback) {
  [...document.querySelectorAll("*")]
    .filter((elem) => {
      if (!elem) return false;
      const style = getComputedStyle(elem);
      if (
        style.position !== "fixed" ||
        style.top !== "0px" ||
        style.visibility === "hidden" ||
        style.pointerEvents === "none"
      )
        return false;
      return true;
    })
    .find((elem) => {
      offset -= elem.offsetHeight;
      return true;
    });

  Velocity(element, "scroll", {
    axis: "y",
    offset,
    duration: 250,
    easing: "ease-in-out",
    complete: () => {
      if (callback) callback();
    },
  });
}

export default {
  getScrollInfo,
  scrollToIndex,
  scrollByPages,
  getItemWidth,
  scrollToElementIfNotInViewport,
  scrollToElement,
};



// WEBPACK FOOTER //
// ./src/utils/scrollTo.js